import { useState, useEffect, useRef } from 'react';

const AudioPlayer = ({started,  audioRef }) => {
  const [isPlaying, setIsPlaying] = useState(started);


  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        audioRef.current?.pause();
      }
      else{
        audioRef.current?.play();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // return () => {
    //   document.removeEventListener("visibilitychange", handleVisibilityChange);
    // };
  }, []);

  useEffect(() => {
    // if(!isPlaying)return;
    console.log("isPlaying "+isPlaying);
    if (isPlaying===true) {
      audioRef.current.play();
     const audio = audioRef.current;
    //    Soft fade-in for music
      let vol = 0;
      const fade = setInterval(() => {
        vol += 0.02;
        audio.volume = Math.min(vol, 0.25);
        if (vol >= 0.25) clearInterval(fade);
      }, 50);
    } else {
      audioRef.current.pause();
    }
  }, [isPlaying, audioRef]);

  // const togglePlayPause = () => {
  //   onToggle?.(); // call parent to toggle started
  // };

  return (
    <div>
      <audio ref={audioRef} src='/bgAudio.mp3'  playsInline loop preload="auto"  controls/>
      
      {/* Add progress bar, volume controls, etc. here */}
    </div>
  );
};

export default AudioPlayer;
